import React, { useEffect, useCallback, useRef, useState } from "react";
import { connect } from 'react-redux'
import UserLayout from '../utils/user/UserLayout'
import {
    fetchCountriesAction,
    fetchSectorAction,
    fetchStatutoryIndustryAction,
    fetchPhasesAction,
    fetchOrganisationAction,
    fetchCompetenciesScoreAction,
    fetchPersonalSkillsAction,
    fetchQualificationsAction,
    fetchEducationsAction,
    fetchFunctionsAction,
    fetchCategoryAction,
    fetchJobTitlesAction,
    fetchSystemAction,
    fetchSystemExperienceAction,
    fetchSystemsExpereinceScoringAction,
} from '../../redux/actions/admin/adminAction'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Sector from "./forms/Sector";
import Phase from "./forms/Phase";
import Organisation from "./forms/Organisation";
import CompetenciesScore from "./forms/CompetenciesScore";
import PersonalSkills from "./forms/PersonalSkills";
import TypesOfSystems from "./forms/TypesOfSystems";
import Education from "./forms/Education";
import Function from "./forms/Function";
import StatutoryIndustryTraining from "./forms/StatutoryIndustryTraining";
import System from "./forms/System";
import SystemExperience from "./forms/SystemExperience";
import Category from "./forms/Category";
import JobTitle from "./forms/JobTitle";
import Qualification from "./forms/Qualification";


export const Admin = (props) => {

    const fetchData = useCallback(() => {
        if (Object.keys(props.countries).length === 0) {
            props.fetchCountries()
        }
        if (Object.keys(props.sector).length === 0) {
            props.fetchSector()
        }
        if (Object.keys(props.statutoryIndustry).length === 0) {
            props.fetchStatutoryIndustry()
        }
        if (Object.keys(props.phases).length === 0) {
            props.fetchPhases()
        }
        if (Object.keys(props.phases).length === 0) {
            props.fetchOrganisation()
        }
        if (Object.keys(props.competenciesScore).length === 0) {
            props.fetchCompetenciesScore()
        }
        if (Object.keys(props.personalSkills).length === 0) {
            props.fetchPersonalSkills()
        }
        if (Object.keys(props.qualifications).length === 0) {
            props.fetchQualifications()
        }
        if (Object.keys(props.educations).length === 0) {
            props.fetchEducations()
        }
        if (Object.keys(props.functions).length === 0) {
            props.fetchFunctions()
        }
        if (Object.keys(props.category).length === 0) {
            props.fetchCategory()
        }
        if (Object.keys(props.jobTitles).length === 0) {
            props.fetchJobTitles()
        }
        if (Object.keys(props.system).length === 0) {
            props.fetchSystem()
        }
        if (Object.keys(props.systemExpereine).length === 0) {
            props.fetchSystemExperience()
        }
        if (Object.keys(props.systemExpereineScoring).length === 0) {
            props.fetchSystemsExpereinceScoring()
        }
    }, [props])

    useEffect(() => {
        fetchData()

    }, []);

    return (
        <UserLayout>
            <div className="right-section">
                <div className="row align-items-end mb-65">
                    <div className="col-sm-6 col-6">
                        <h2 className="page-title">
                            <strong>Admin</strong>
                        </h2>
                    </div>
                </div>
                <div className="row margin-row">
                    <div className="col-12 card-block">
                        <div className="card-border">
                            <Tabs>
                                <TabList>
                                    <Tab>Sector</Tab>
                                    <Tab>Statutory Industry Training</Tab>
                                </TabList>

                                <TabPanel>
                                    <Sector />
                                </TabPanel>
                                <TabPanel>
                                    <StatutoryIndustryTraining />
                                </TabPanel>
                            </Tabs>
                            <br></br>
                            <br></br>
                            <Tabs>
                                <TabList>
                                    <Tab>Types of Systems</Tab>
                                    <Tab>Systems</Tab>
                                    <Tab>Systems Experience Scoring</Tab>
                                </TabList>

                                <TabPanel>
                                    <TypesOfSystems />
                                </TabPanel>
                                <TabPanel>
                                    <System />
                                </TabPanel>
                                <TabPanel>
                                    <SystemExperience />
                                </TabPanel>
                            </Tabs>

                            <br></br>
                            <br></br>
                            <Tabs>
                                <TabList>
                                    <Tab>Function</Tab>
                                    <Tab>Category</Tab>
                                    <Tab>JobTitle</Tab>
                                </TabList>

                                <TabPanel>
                                    <Function />
                                </TabPanel>
                                <TabPanel>
                                    <Category />
                                </TabPanel>
                                <TabPanel>
                                    <JobTitle />
                                </TabPanel>
                            </Tabs>

                            <br></br>
                            <br></br>
                            <Tabs>
                                <TabList>
                                    <Tab>Education</Tab>
                                    <Tab>Qualification</Tab>
                                </TabList>

                                <TabPanel>
                                    <Education />
                                </TabPanel>

                                <TabPanel>
                                    <Qualification />
                                </TabPanel>
                            </Tabs>

                            <br></br>
                            <br></br>
                            <Tabs>
                                <TabList>
                                    <Tab>Phases</Tab>
                                    <Tab>Organisation</Tab>
                                    <Tab>Competencies Score</Tab>
                                    <Tab>Personal Skills</Tab>
                                </TabList>

                                <TabPanel>
                                    <Phase />
                                </TabPanel>
                                <TabPanel>
                                    <Organisation />
                                </TabPanel>
                                <TabPanel>
                                    <CompetenciesScore />
                                </TabPanel>
                                <TabPanel>
                                    <PersonalSkills />
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </UserLayout >
    )
}

const mapStateToProps = (state) => {

    const countries = state.admin.countries;
    const sector = state.admin.sector;
    const statutoryIndustry = state.admin.statutoryIndustry;
    const phases = state.admin.phases;
    const organisations = state.admin.organisations;
    const competenciesScore = state.admin.competenciesScore;
    const personalSkills = state.admin.personalSkills;
    const qualifications = state.admin.qualifications;
    const educations = state.admin.educations;
    const functions = state.admin.functions;
    const category = state.admin.category;
    const jobTitles = state.admin.jobTitles;
    const system = state.admin.system;
    const systemExpereine = state.admin.systemExpereine;
    const systemExpereineScoring = state.admin.systemExpereineScoring;

    return {

        countries: countries,
        sector: sector,
        statutoryIndustry: statutoryIndustry,
        phases: phases,
        organisations: organisations,
        competenciesScore: competenciesScore,
        personalSkills: personalSkills,
        qualifications: qualifications,
        educations: educations,
        functions: functions,
        category: category,
        jobTitles: jobTitles,
        system: system,
        systemExpereine: systemExpereine,
        systemExpereineScoring: systemExpereineScoring,

    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        fetchCountries: () => dispatch(fetchCountriesAction()),
        fetchSector: () => dispatch(fetchSectorAction()),
        fetchStatutoryIndustry: () => dispatch(fetchStatutoryIndustryAction()),
        fetchPhases: () => dispatch(fetchPhasesAction()),
        fetchOrganisation: () => dispatch(fetchOrganisationAction()),
        fetchCompetenciesScore: () => dispatch(fetchCompetenciesScoreAction()),
        fetchPersonalSkills: () => dispatch(fetchPersonalSkillsAction()),
        fetchQualifications: () => dispatch(fetchQualificationsAction()),
        fetchEducations: () => dispatch(fetchEducationsAction()),
        fetchFunctions: () => dispatch(fetchFunctionsAction()),
        fetchCategory: () => dispatch(fetchCategoryAction()),
        fetchJobTitles: () => dispatch(fetchJobTitlesAction()),
        fetchSystem: () => dispatch(fetchSystemAction()),
        fetchSystemExperience: () => dispatch(fetchSystemExperienceAction()),
        fetchSystemsExpereinceScoring: () => dispatch(fetchSystemsExpereinceScoringAction()),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Admin)